class ActiveFilters extends HTMLElement {
    constructor() {
        super();
        this.lengthFilterAnchor = this.querySelector(".length-filter a");
        this.heightFilterAnchor = this.querySelector(".height-filter a");
        this.widthFilterAnchor = this.querySelector(".width-filter a");
        this.lengthFilter = this.querySelector(".length-filter");
        this.heightFilter = this.querySelector(".height-filter");
        this.widthFilter = this.querySelector(".width-filter");
    }

    connectedCallback() {
        this.init();
    }

    init() {
        {

            const hnadleRemove = function (e) {
                e.preventDefault()
                const url = new URL(window.location.href);
                url.searchParams.delete('filter.v.m.custom.filter_laenge1');
                url.searchParams.delete('filter.v.m.custom.filter_laenge1_min');
                url.searchParams.delete('filter.v.m.custom.filter_laenge1_max');
                window.history.replaceState({}, '', url);
                window.location.reload()
            }.bind(this)

            const updateAppliedRange = function () {
                const url = new URL(window.location.href);
                const min_value = parseInt(url.searchParams.get('filter.v.m.custom.filter_laenge1_min'))
                const max_value = parseInt(url.searchParams.get('filter.v.m.custom.filter_laenge1_max'))

                this.lengthFilterAnchor.innerHTML = `<strong>Länge:&nbsp</strong> <span>${min_value} cm - ${max_value} cm</span>`
            }.bind(this)

            const selectValues = function (filterMinValue, filterMaxValue) {
                const url = new URL(window.location.href);
                const inputs = this.querySelectorAll("[name='filter.v.m.custom.filter_laenge1']");
                const filteredInputs = Array.from(inputs).filter(function (input) {
                    const value = parseFloat(input.value.replace(' cm', ''));
                    return value >= filterMinValue && value <= filterMaxValue;
                });
                filteredInputs.forEach(input => {
                    url.searchParams.append('filter.v.m.custom.filter_laenge1', input.value);
                    input.setAttribute("checked", true)
                    input.closest(".tag").classList.add("tag--active")
                });
                window.history.replaceState({}, '', url);
            }.bind(this)

            const getQueryParam = function (param) {
                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);
                return params.get(param);
            }.bind(this)

            const removeLengthFilter = function () {
                const url = new URL(window.location.href);
                url.searchParams.delete('filter.v.m.custom.filter_laenge1');
                window.history.replaceState({}, '', url);

                const inputs = this.querySelectorAll("[name='filter.v.m.custom.filter_laenge1']");
                inputs.forEach(input => {
                    input.removeAttribute("checked")
                    input.closest(".tag").classList.remove("tag--active")
                })
            }.bind(this);

            const updateLengthFilter = function (dispatchCollectionReload = 1) {

                const url = new URL(window.location.href);
                if (!url.searchParams.get('filter.v.m.custom.filter_laenge1_min') && !url.searchParams.get('filter.v.m.custom.filter_laenge1_max')) {

                    this.lengthFilter?.remove()
                    return
                }

                this.lengthFilter?.addEventListener("click", hnadleRemove)
                // update the range filter
                updateAppliedRange();

                const lengthRange = this.querySelector('.length-range');
                const filterMinValue = parseFloat(getQueryParam('filter.v.m.custom.filter_laenge1_min')) || lengthRange.dataset.min;
                const filterMaxValue = parseFloat(getQueryParam('filter.v.m.custom.filter_laenge1_max')) || lengthRange.dataset.max;

                const minInput = this.querySelector('input[name="filter.v.m.custom.filter_laenge1_min"]');
                const maxInput = this.querySelector('input[name="filter.v.m.custom.filter_laenge1_max"]');

                if (minInput && maxInput && lengthRange) {
                    minInput.value = filterMinValue;
                    maxInput.value = filterMaxValue;
                    lengthRange.setAttribute('data-min-value', filterMinValue);
                    lengthRange.setAttribute('data-max-value', filterMaxValue);
                }

                removeLengthFilter();
                selectValues(filterMinValue, filterMaxValue);

                if (dispatchCollectionReload >= 4) {
                    return;
                }

            }.bind(this);

            updateLengthFilter();

        }
        {

            const hnadleRemove = function (e) {
                e.preventDefault()
                const url = new URL(window.location.href);
                url.searchParams.delete('filter.v.m.custom.filter_breite1');
                url.searchParams.delete('filter.v.m.custom.filter_breite1_min');
                url.searchParams.delete('filter.v.m.custom.filter_breite1_max');
                window.history.replaceState({}, '', url);
                window.location.reload()
            }.bind(this);

            const updateAppliedRange = function () {
                const url = new URL(window.location.href);
                const min_value = parseInt(url.searchParams.get('filter.v.m.custom.filter_breite1_min'))
                const max_value = parseInt(url.searchParams.get('filter.v.m.custom.filter_breite1_max'))

                this.widthFilterAnchor.innerHTML = `<strong>Breite:&nbsp</strong> <span>${min_value} cm - ${max_value} cm</span>`
            }.bind(this)

            const selectValues = function (filterMinValue, filterMaxValue) {
                const url = new URL(window.location.href);
                const inputs = this.querySelectorAll("[name='filter.v.m.custom.filter_breite1']");
                const filteredInputs = Array.from(inputs).filter(function (input) {
                    const value = parseFloat(input.value.replace(' cm', ''));
                    return value >= filterMinValue && value <= filterMaxValue;
                });
                filteredInputs.forEach(input => {
                    url.searchParams.append('filter.v.m.custom.filter_breite1', input.value);
                    input.setAttribute("checked", true)
                    input.closest(".tag").classList.add("tag--active")
                });
                window.history.replaceState({}, '', url);
            }.bind(this);

            const getQueryParam = function (param) {
                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);
                return params.get(param);
            }.bind(this);

            const removeWidthFilter = function () {
                const url = new URL(window.location.href);
                url.searchParams.delete('filter.v.m.custom.filter_breite1');
                window.history.replaceState({}, '', url);

                const inputs = this.querySelectorAll("[name='filter.v.m.custom.filter_breite1']");
                inputs.forEach(input => {
                    input.removeAttribute("checked")
                    input.closest(".tag").classList.remove("tag--active")
                })
            }.bind(this)

            const updateWidthFilter = function (dispatchCollectionReload = 1) {

                const url = new URL(window.location.href);
                if (!url.searchParams.get('filter.v.m.custom.filter_breite1_min') && !url.searchParams.get('filter.v.m.custom.filter_breite1_max')) {
                    this.widthFilter?.remove()
                    return
                }

                this.widthFilter?.addEventListener("click", hnadleRemove)
                // update the range filter
                updateAppliedRange();

                const widthRange = this.querySelector('.width-range');
                const filterMinValue = parseFloat(getQueryParam('filter.v.m.custom.filter_breite1_min')) || widthRange.dataset.min;
                const filterMaxValue = parseFloat(getQueryParam('filter.v.m.custom.filter_breite1_max')) || widthRange.dataset.max;

                const minInput = this.querySelector('input[name="filter.v.m.custom.filter_breite1_min"]');
                const maxInput = this.querySelector('input[name="filter.v.m.custom.filter_breite1_max"]');

                if (minInput && maxInput && widthRange) {
                    minInput.value = filterMinValue;
                    maxInput.value = filterMaxValue;
                    widthRange.setAttribute('data-min-value', filterMinValue);
                    widthRange.setAttribute('data-max-value', filterMaxValue);
                }

                removeWidthFilter();
                selectValues(filterMinValue, filterMaxValue);

                if (dispatchCollectionReload >= 4) {
                    return;
                }


            }.bind(this)

            updateWidthFilter();

        };

        {

            const hnadleRemove = function (e) {
                e.preventDefault()
                const url = new URL(window.location.href);
                url.searchParams.delete('filter.v.m.custom.filter_hoehe1');
                url.searchParams.delete('filter.v.m.custom.filter_hoehe1_min');
                url.searchParams.delete('filter.v.m.custom.filter_hoehe1_max');
                window.history.replaceState({}, '', url);
                window.location.reload()
            }.bind(this)

            const updateAppliedRange = function () {
                const url = new URL(window.location.href);
                const min_value = parseInt(url.searchParams.get('filter.v.m.custom.filter_hoehe1_min'))
                const max_value = parseInt(url.searchParams.get('filter.v.m.custom.filter_hoehe1_max'))

                this.heightFilterAnchor.innerHTML = `<strong>Höhe:&nbsp</strong> <span>${min_value} cm - ${max_value} cm</span>`
            }.bind(this)

            const selectValues = function (filterMinValue, filterMaxValue) {
                const url = new URL(window.location.href);
                const inputs = this.querySelectorAll("[name='filter.v.m.custom.filter_hoehe1']");
                const filteredInputs = Array.from(inputs).filter(function (input) {
                    const value = parseFloat(input.value.replace(' cm', ''));
                    return value >= filterMinValue && value <= filterMaxValue;
                });
                filteredInputs.forEach(input => {
                    url.searchParams.append('filter.v.m.custom.filter_hoehe1', input.value);
                    input.setAttribute("checked", true)
                    input.closest(".tag").classList.add("tag--active")
                });
                window.history.replaceState({}, '', url);
            }.bind(this);

            const getQueryParam = function (param) {
                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);
                return params.get(param);
            }.bind(this)

            const removeHeightFilter = function () {
                const url = new URL(window.location.href);
                url.searchParams.delete('filter.v.m.custom.filter_hoehe1');
                window.history.replaceState({}, '', url);

                const inputs = this.querySelectorAll("[name='filter.v.m.custom.filter_hoehe1']");
                inputs.forEach(input => {
                    input.removeAttribute("checked")
                    input.closest(".tag").classList.remove("tag--active")
                })
            }.bind(this)

            const updateHeightFilter = function (dispatchCollectionReload = 1) {

                const url = new URL(window.location.href);
                if (!url.searchParams.get('filter.v.m.custom.filter_hoehe1_min') && !url.searchParams.get('filter.v.m.custom.filter_hoehe1_max')) {
                    this.heightFilter?.remove()
                    return
                }

                this.heightFilter?.addEventListener("click", hnadleRemove)
                // update the range filter
                updateAppliedRange();

                const heightRange = this.querySelector('.height-range');
                const filterMinValue = parseFloat(getQueryParam('filter.v.m.custom.filter_hoehe1_min')) || heightRange.dataset.min;
                const filterMaxValue = parseFloat(getQueryParam('filter.v.m.custom.filter_hoehe1_max')) || heightRange.dataset.max;

                const minInput = this.querySelector('input[name="filter.v.m.custom.filter_hoehe1_min"]');
                const maxInput = this.querySelector('input[name="filter.v.m.custom.filter_hoehe1_max"]');

                if (minInput && maxInput && heightRange) {
                    minInput.value = filterMinValue;
                    maxInput.value = filterMaxValue;
                    heightRange.setAttribute('data-min-value', filterMinValue);
                    heightRange.setAttribute('data-max-value', filterMaxValue);
                }

                removeHeightFilter();
                selectValues(filterMinValue, filterMaxValue);

                if (dispatchCollectionReload >= 4) {
                    return;
                }


            }.bind(this);

            updateHeightFilter();

        }
    }

}

customElements.define('active-filters', ActiveFilters);
